export const getHoursBags = (company) => {
    const HOURS_BAG_1_ID = 1;
    const HOURS_BAG_2_ID = 2;
    const HOURS_BAG_3_ID = 3;
    const HOURS_BAG_4_ID = 4;
    const HOURS_BAG_5_ID = 5;
    const HOURS_BAG_VACATION_ID = 6;    
    const HOURS_BAG_EXTRA_ID = 7;
    let hoursBags = [];
    // bolsa dias vacaciones
			let hoursBag = new HoursBag(HOURS_BAG_VACATION_ID, company.id, company.defaultYearlyVacationDays, company.defaultYearlyVacationLabel, true);
			hoursBags.push(hoursBag);

			// bolsa dias libres
			hoursBag = new HoursBag(HOURS_BAG_EXTRA_ID, company.id, company.defaultYearlyExtraDays, company.defaultYearlyExtraLabel, company.defaultYearlyExtraEnabled);
			hoursBags.push(hoursBag);

			// bolsas
			hoursBag = new HoursBag(HOURS_BAG_1_ID, company.id, company.defaultYearlyHoursBag1Days, company.defaultYearlyHoursBag1Label, company.defaultYearlyHoursBag1Enabled);
			hoursBags.push(hoursBag);

			hoursBag = new HoursBag(HOURS_BAG_2_ID, company.id, company.defaultYearlyHoursBag2Days, company.defaultYearlyHoursBag2Label, company.defaultYearlyHoursBag2Enabled);
			hoursBags.push(hoursBag);

			hoursBag = new HoursBag(HOURS_BAG_3_ID, company.id, company.defaultYearlyHoursBag3Days, company.defaultYearlyHoursBag3Label, company.defaultYearlyHoursBag3Enabled);
			hoursBags.push(hoursBag);

			hoursBag = new HoursBag(HOURS_BAG_4_ID, company.id, company.defaultYearlyHoursBag4Days, company.defaultYearlyHoursBag4Label, company.defaultYearlyHoursBag4Enabled);
			hoursBags.push(hoursBag);

			hoursBag = new HoursBag(HOURS_BAG_5_ID, company.id, company.defaultYearlyHoursBag5Days, company.defaultYearlyHoursBag5Label, company.defaultYearlyHoursBag5Enabled);
			hoursBags.push(hoursBag);
    return hoursBags;
}

class HoursBag {
    constructor(id, companyId, days, label, enabled) {
        this.id = id;
        this.companyId = companyId;
        this.days = days;
        this.label = label;
        this.enabled = enabled;
    }
}
    
    